import Sortable from 'sortablejs';

// properties
function bootstrap_select_search() {
  $(".select_with_search").selectpicker({
    liveSearch: true,
    size: 10,
    actionsBox: true
  });
  $(".bootstrap_select").selectpicker({
    size: 10
  });
}

$(document).on("turbolinks:load", function () {
  const modal_holder_selector = "#modal-holder";
  const modal_selector = ".modal";

  var el = document.getElementsByClassName('general-sortable');
  if (el.length) {
    var _dragClientY = 0;
    var _autoScrollRAF = null;
    var NAVBAR_HEIGHT = document.querySelector('.navbar, .topbar, nav') ? document.querySelector('.navbar, .topbar, nav').offsetHeight : 70;
    var SCROLL_ZONE = 80;
    var SCROLL_SPEED = 12;

    var _dragClientYCaptured = false;

    function _autoScrollStep() {
      if (_dragClientYCaptured && _dragClientY < NAVBAR_HEIGHT + SCROLL_ZONE) {
        var intensity = 1 - (_dragClientY - NAVBAR_HEIGHT) / SCROLL_ZONE;
        window.scrollBy(0, -Math.ceil(SCROLL_SPEED * Math.max(intensity, 0.2)));
      }
      _autoScrollRAF = requestAnimationFrame(_autoScrollStep);
    }

    function _onDragMove(e) {
      _dragClientY = e.clientY;
      _dragClientYCaptured = true;
    }

    new Sortable(el[0], {
      handle: '.sort-handle',
      animation: 150,
      scroll: true,
      scrollSensitivity: 80,
      scrollSpeed: 10,
      bubbleScroll: true,
      onStart: function (evt) {
        _dragClientY = evt.originalEvent.clientY;
        _dragClientYCaptured = true;
        document.addEventListener('dragover', _onDragMove);
        document.addEventListener('mousemove', _onDragMove);
        _autoScrollRAF = requestAnimationFrame(_autoScrollStep);
      },
      onEnd: function (evt) {
        _dragClientYCaptured = false;
        document.removeEventListener('dragover', _onDragMove);
        document.removeEventListener('mousemove', _onDragMove);
        cancelAnimationFrame(_autoScrollRAF);
        _autoScrollRAF = null;
        reset_positions();
      }
    });
  }

  const modalModifierSetContainers = document.querySelectorAll('.modifier-set-modifier-sortable');
  modalModifierSetContainers.forEach((container) => {
    new Sortable(container, {
      group: 'nested-modifier-set',
      handle: '.sort-handle',
      animation: 150,
      onEnd: function () {
        reset_positions();
      }
    });
  });

  const modalTopLevelModifiers = document.querySelectorAll('.modifier-sortable');
  modalTopLevelModifiers.forEach((container) => {
    new Sortable(container, {
      group: 'top-level-modifier',
      handle: '.sort-handle',
      animation: 150,
      onEnd: function () {
        reset_positions();
      }
    });
  });


  $("#item_modifier_sets, #modifier_set_modifiers").on("cocoon:after-insert", function (e, added_row) {
    bootstrap_select_search();
    add_new_modifier();
    added_row.find('.position').val($('.nested-position-fields:visible').length);
  });

  $("#sub_category_modifier_sets").on("cocoon:after-insert", function (e, added_row) {
    bootstrap_select_search();
    add_new_sub_category_modifier();
    added_row.find('.position').val($('.nested-position-fields:visible').length);
  });

  $("#permissions").on("cocoon:after-insert", function (e, added_row) {
    added_row.find('.position').val($('.nested-position-fields:visible').length);
    // auto-expand new rows so name/description are immediately editable
    added_row.find('.permission-name-text').addClass('d-none');
    added_row.find('.permission-name-input').removeClass('d-none');
    added_row.find('.permission-desc-row').removeClass('d-none');
    added_row.find('.permission-expand-btn i').removeClass('fa-chevron-down').addClass('fa-chevron-up');
  });

  // expand/collapse permission description row (unbound first to prevent duplicate handlers on turbolinks navigation)
  $(document).off('click.permissionExpand').on('click.permissionExpand', '.permission-expand-btn', function (e) {
    e.preventDefault();
    var row = $(this).closest('.permission-row');
    var descRow = row.find('.permission-desc-row');
    var icon = $(this).find('i');
    descRow.toggleClass('d-none');
    icon.toggleClass('fa-chevron-down fa-chevron-up');
  });

  $('#modifiers, #item_modifier_sets, #modifier_set_modifiers, #floor_menu_categories').on('cocoon:after-remove', function (e, insertedItem, originalEvent) {
    reset_positions();
  });

  $('#modifiers, #item_modifier_sets, #floor_menu_categories, #permissions').on('cocoon:after-remove', function (e, insertedItem, originalEvent) {
    reset_positions();
  });

  $("#item_ingredients").on("cocoon:after-insert", function (e, added_row) {
    bootstrap_select_search();
    add_new_ingredient();
  });

  $(".item_modifier_set").on("change", function () {
    add_new_modifier();
  });

  $(".sub_category_modifier_set").on("change", function () {
    add_new_sub_category_modifier();
  });

  $(".add_item_ingredient").on("change", function () {
    console.log("funs");
    add_new_ingredient();
  });

  function add_new_modifier() {
    $(".item_modifier_set").on("change", function () {
      if ($(this).val() == "create") {
        var el = $(this).attr("id");
        open_remote_model(
          "/products/modifier_sets/new_popup?resp_type=dropdown&el=" + el
        );
      }
    });
  }

  function add_new_sub_category_modifier() {
    $(".sub_category_modifier_set").on("change", function () {
      if ($(this).val() == "create") {
        var el = $(this).attr("id");
        open_remote_model(
          "/products/modifier_sets/new_popup?resp_type=dropdown&el=" + el
        );
      }
    });
  }

  function add_new_ingredient() {
    $(".add_item_ingredient").on("change", function () {
      if ($(this).val() == "create") {
        var el = $(this).attr("id");
        open_remote_model(
          "/products/ingredients/new_popup?resp_type=dropdown&el=" + el
        );
      }
    });
  }

  function open_remote_model(location) {
    const modal_holder_selector = "#modal-holder";
    const modal_selector = ".modal";
    $.get(location, data => {
      $(modal_holder_selector)
        .html(data)
        .find(modal_selector)
        .modal("show");
    });
  }

  function reset_positions() {
    // only consider visible ones
    $('.nested-position-fields:visible').each(function (index) {
      $(this).find('.position').val(index + 1);
    });
  }

  $(document).on('shown.bs.modal', function () {
    var el = document.getElementsByClassName('item-general-sortable');
    if (el.length) {
      new Sortable(el[0], {
        handle: '.sort-handle',
        animation: 150,
        onEnd: function () {
          $('.item-general-sortable .nested-fields').each(function (index) {
            $(this).find('.position').val(index + 1);
          });
        }
      });
    }
  });
  

  $(document).on("ajax:success", "form[data-modal]", function (event) {
    const [data, _status, xhr] = event.detail;
    console.log(data);
    if (data.resp_type != "dropdown") {
      // Redirect to url
      window.location = "";
    } else {
      el = "#" + data.el;
      console.log(el);
      $(el).append(new Option(data.name, data.id, false, true));
      $(el).selectpicker("refresh");
      $(modal_selector).modal("hide");
    }

    return false;
  });
});
